import React from 'react';
import ConsultingHeroSection from '../Components/Consulting/ConsultingHeroSection.jsx';
import FloatingNotesTimeline from '../Components/Consulting/FloatingNotesTimeline.jsx';
const Consulting = () => {
  return (

    <main className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/40 pb-16">
        <ConsultingHeroSection />
        <FloatingNotesTimeline />
      {/* <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center px-6 py-3 bg-[#1719A8]/90 backdrop-blur-md border border-[#1719A8]/60 rounded-full mb-6 shadow-lg">
            <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
            <span className="text-white font-semibold uppercase tracking-wider text-sm">
              Enterprise Consulting
            </span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-black mb-8 tracking-tight text-slate-900">
            Strategic Technology
            <span className="block bg-gradient-to-r from-[#1719A8] to-[#D96F2B] bg-clip-text text-transparent">
              Consulting Services
            </span>
          </h1>

          <p className="text-xl leading-relaxed max-w-3xl mx-auto text-slate-600 mb-12">
            Transform your business with expert technology consulting, digital strategy,
            and enterprise solutions designed to accelerate growth and innovation.
          </p>

          <div className="bg-gradient-to-br from-[#1719A8] to-[#0F1280] backdrop-blur-xl rounded-3xl border border-white/30 p-12 shadow-2xl">
           <div className="inline-flex items-center px-6 py-3 ">
            <span className="w-6 h-6 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full mr-3 animate-pulse"></span>
            <span className="text-white font-semibold uppercase tracking-wider text-3xl lg:text-4xl">
              Coming Soon
            </span>
          </div>
            <p className="text-lg text-gray-300 mb-8">
              Our comprehensive consulting services page is under development.
              We're crafting detailed information about our strategic technology consulting,
              digital transformation services, and enterprise solutions.
            </p>
            
          </div>
        </div>
      </div> */}
    </main>
  );
};

export default Consulting;
